import { ScrollModule } from '@enauka/shared/ui/scroll';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedAuthFeatureLoginModule } from '@enauka/shared/infrastructure/auth/feature-login';
import { FormlyModule } from '@ngx-formly/core';
import { StronaGlownaModule } from '../strona-glowna/strona-glowna.module';
import { HeaderComponent } from './header/header.component';
import { FormularzKontaktowyComponent } from './home-zeszyt/formularz-kontaktowy/formularz-kontaktowy.component';
import { HomeZeszytComponent } from './home-zeszyt/home-zeszyt.component';
import { LogowanieZeszytComponent } from './logowanie/logowanie-zeszyt.component';
import { RegulaminComponent } from './regulamin/regulamin.component';
import { SimpleHeaderComponent } from './simple-header/simple-header.component';
import { SiteLayoutComponent } from './site-layout/site-layout.component';
import { ZeszytOnlineRoutingModule } from './zeszyt-online-routing';
import { CasComponent } from './cas/cas.component';
import { FontAwesomeModule } from '@enauka/shared/ui/font-awesome';
import { OpinieComponent } from './home-zeszyt/opinie/opinie.component';
import { WynikiRzewnieComponent } from './home-zeszyt/wyniki-rzewnie/wyniki-rzewnie.component';
import { EnaukaNavBarComponent } from './enauka-nav-bar/enauka-nav-bar.component';
import { ZeszytWPwComponent } from './zeszyt-w-pw/zeszyt-w-pw.component';



@NgModule({
  declarations: [
    SiteLayoutComponent,
    SimpleHeaderComponent,
    HeaderComponent,
    HomeZeszytComponent,
    RegulaminComponent,
    FormularzKontaktowyComponent,
    LogowanieZeszytComponent,
    CasComponent,
    OpinieComponent,
    WynikiRzewnieComponent,
    EnaukaNavBarComponent,
    ZeszytWPwComponent,
  ],
  imports: [
    CommonModule,
    ZeszytOnlineRoutingModule,
    StronaGlownaModule,
    FormlyModule,
    FormsModule,
    SharedAuthFeatureLoginModule,
    FontAwesomeModule,
    ScrollModule,
  ]
})
export class ZeszytOnlineModule { }
